module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Regular-46135e88843bc5c4903b245ac5077e89.svg";